import { render } from "./Error404View.vue?vue&type=template&id=5b3e60da&scoped=true"
import script from "./Error404View.vue?vue&type=script&lang=js"
export * from "./Error404View.vue?vue&type=script&lang=js"

import "./Error404View.vue?vue&type=style&index=0&id=5b3e60da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3e60da"]])

export default __exports__